import React,{ useEffect, useState } from 'react'
import AdminListing from '../../../common/adminListing'
import SearchBar from '../../../common/commonSearchBar';
import { holidaysbookingStatusValues } from '../../../resources/status';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../../common/pagination';
import CommonMoreInfoModel from '../../../common/commonMoreInfoModel';
import ConfirmRefundModal from '../../../common/confirmRefundModel';

import { 
    getHolidayBookingList, 
    holidayBookingsSearch, 
    holidayBookingStatusUpdate,
    pageId,
    holidayBookingSearchValue
} from '../../../actions/holidayBookingAction';
import ClosedModal from '../requests/closeRequestModal';
import { checkNumberOfGuest, isCorporate} from '../../../utils/index';
import { closeRequestInputVal } from '../../../actions/holidayRequestAction';

import moment from 'moment'
const Refunded = () => {
    const [ showMoreInfo, setShowMoreInfo ] = useState(false);
    const [ moreInfoData, setMoreInfoData ] = useState({});
    const [ searchVal, setSearchVal ] = useState('');
    const [ pageVal, setPageVal ] = useState(1);
    const [status, setStatus] = useState('');
    const [id, setId] = useState(null);
    const[iscopr,setIscorp]=useState()
    const [ statusChangeBool, setStatusChangeBool ] = useState(false);
    const[averageBookingAmount,setAverageBookingAmount]=useState()
    const[totalbookingAmount,setTotalbookingAmount]=useState()
    const [requestModal, setRequestModal] = useState(false);
    const [closeRequestModalData, setCloseRequestModalData] = useState({});
    const [isclosingMessageBool, setIsclosingMessageBool] = useState(null);
   

    const holidayBooked = useSelector(state => state.holidayBooking);
    const refundedBooking = useSelector(state => state.holidayBooking.refundBooking.results);

    console.log(holidayBooked,"refundedBooking");
    const totapPage = useSelector(state => state.holidayBooking.refundBooking.total_pages);
    const pageNum = useSelector(state => state.holidayBooking.page);
    const sectionID = useSelector(state => state.holidayBooking.bookingsSecId);
    const holidayRefundNxtPgeId = useSelector(state => state.holidayBooking.holidayRefundNxtPgeId);
    const holidayRefundCurrentPgeId = useSelector(state => state.holidayBooking.holidayRefundCurrentPgeId);
    const holidayRefundSearchVal = useSelector(state => state.holidayBooking.holidayRefundSearchVal);
    const ffStartDate = useSelector((state) => state.holidayBooking.holidayBookingStartDate);
   const ffEndDate = useSelector((state) => state.holidayBooking.holidayookingEndDate);
   const closeRequestMessage = useSelector(state => state.holidayRequest.closeRequestMsg);
    const dispatch = useDispatch();
    useEffect(() => {
        window.scrollTo(0, 0);
        return ()=> document.body.style.overflow = 'unset';
    }, [showMoreInfo]);

    useEffect(() => {
        if(holidayRefundNxtPgeId === null && holidayRefundCurrentPgeId > 1 && refundedBooking?.length === 0) {
            dispatch(getHolidayBookingList(1, sectionID, "booked"));
            dispatch(pageId(1));
            setPageVal(1);
        }
    }, [refundedBooking, pageVal]);

    const handlePagination = (e, value) => {
        setPageVal(value);
        if(holidayRefundSearchVal !== "" || ffStartDate !== null && ffEndDate !== null){
            dispatch(holidayBookingsSearch(value, 'booked', holidayRefundSearchVal, sectionID, ffStartDate, ffEndDate))
            dispatch(pageId(value));
        }else{
            dispatch(getHolidayBookingList(value, sectionID, "booked"));
            dispatch(pageId(value));
        }
    };

    const moreInfoHandler = (data) => {
        setMoreInfoData(data);
        setShowMoreInfo(true);
    };
    const handleRefund=(id)=>{
}

    const handleChange = (e) => {
        e.preventDefault() 
        console.log(e.target.value,"e.target.value");
        setSearchVal(e.target.value);
        dispatch(holidayBookingsSearch(1, 'refunded', e.target.value, sectionID, ffStartDate, ffEndDate))
        dispatch(holidayBookingSearchValue(e.target.value, "refunded"))
        dispatch(pageId(1));
    };

    const refreshHolidayBooking = () => {
        if(searchVal !== '' ) {
            dispatch(holidayBookingsSearch(pageNum, 'booked', searchVal, sectionID, ffStartDate, ffEndDate));
            dispatch(getHolidayBookingList(pageNum, sectionID, "confirmed"));
            dispatch(getHolidayBookingList(pageNum, sectionID, "cancelled"));
        }else if(ffStartDate !== null && ffEndDate !== null){
            dispatch(holidayBookingsSearch(pageNum, 'confirmed', searchVal, sectionID, ffStartDate, ffEndDate));
            dispatch(holidayBookingsSearch(pageNum, 'cancelled', searchVal, sectionID, ffStartDate, ffEndDate));
            dispatch(holidayBookingsSearch(pageNum, 'booked', searchVal, sectionID, ffStartDate, ffEndDate));

        } else {
            dispatch(getHolidayBookingList(pageNum, sectionID, "booked"))
            dispatch(getHolidayBookingList(pageNum, sectionID, "confirmed"))
            dispatch(getHolidayBookingList(pageNum, sectionID, "cancelled"))
        }
    };

    const statusChangeHandler = (event, id, corporate, requestsType, data) => {
        setCloseRequestModalData(data)
        let status = event.target.value;
        setStatusChangeBool(true)
        setStatus(status);
        setId(id);
        setIscorp(corporate)
        if(status === "cancelled")setRequestModal(true);
        else{
            dispatch(holidayBookingStatusUpdate(status, id, corporate,sectionID,null, refreshHolidayBooking));
        // dispatch(getHolidayBookingList(pageNum, sectionID, "confirmed"))
        // dispatch(getHolidayBookingList(pageNum, sectionID, "cancelled"))
        dispatch(pageId(pageVal));

        }
        
    };


    useEffect(()=>{
        const data=refundedBooking?.map((elem)=>{
            return parseInt(elem.amount)
        })
        const totalamount=data?.reduce((acc,elem)=>{
            return acc+elem
        },0)
        setTotalbookingAmount(totalamount)
        setAverageBookingAmount(totalamount/refundedBooking?.length)

    },[refundedBooking])
 const holidayBookingDisplayData = refundedBooking && refundedBooking.map(data => (
        <AdminListing 
            packTitle={data.pack_title}
            address={data?.sec_name  && data?.sec_name == "International" ? data.location_country : data.address}
            amount={isCorporate(data.corporate, data.total_points, data.amount_paid)}
            schedule={Array.isArray(data.schedule) ? data.schedule.sort().map((scheduleDate, index) => {
                if (data.schedule[index] === data.schedule[data.schedule.length - 1]) {
                  return scheduleDate
                } else {
                  return `${scheduleDate}, `
                }
              }) : (typeof data.schedule === 'object' && data.schedule !== null ? `${data.schedule.from} ${data.schedule.to ? `to ${data.schedule.to}` : ""}` : (data.schedule ===  null ? "N/A" : data.schedule))}
            noOfGuest={checkNumberOfGuest(data.adults, data.children, data.infants)}
            specialRequest={data.special_request?data.special_request:"N/A"}
            messageTitle={data.special_request}
            isHolidayBooking={true}
            value={data.booking_status}
            statusValues={holidaysbookingStatusValues}
            onClick={() => moreInfoHandler(data)}
            id={data.id}
            data={data}
            refCode={data.ref_id ? `#${data.ref_id}` : "No ref id"}
            isHolidayRequest={false}
            corporate={data.corporate}
            statusChangeHandler={statusChangeHandler}
            handleRefund={handleRefund}
            status={"refunded"}
            voucher_info={data?.voucher_info}
            isRefunded={true}
       />
    ));

    const closeRequestHandler = () => {
 
        setIsclosingMessageBool(false)
        if(closeRequestMessage === "")setIsclosingMessageBool(true)
       else {
            dispatch(holidayBookingStatusUpdate(status, id, iscopr, sectionID, closeRequestMessage,refreshHolidayBooking))
          setRequestModal(false)
        }
        dispatch(closeRequestInputVal(''));
      };

    const notToCancel=()=>{
        setRequestModal(false)
        setIsclosingMessageBool(false);
    
    }

    return(
        <>
            <SearchBar
                searchVal={holidayRefundSearchVal}
                handleChange={handleChange}
            />
            {refundedBooking && refundedBooking?.length === 0 && 
             <div className="enquiry-card-holder">No Record Found!</div>
            }

    
      <p style={{display:"flex",}}><span><b>Total Order Value: {" "} {totalbookingAmount?Math.round(totalbookingAmount):""}</b> </span>

 <span style={{marginLeft:"80px"}}><b> 
 Average Order Value: {" "} {averageBookingAmount?Math.round(averageBookingAmount):""}
 </b>
  </span></p>
            {holidayBookingDisplayData}
            {showMoreInfo && 
                <CommonMoreInfoModel 
                    open={showMoreInfo}
                    modalClose={() => setShowMoreInfo(false)}
                    moreInfoData={moreInfoData}
                    isCancellationMessage={false}
                />
            }
         
            <Pagination 
                totalPage={totapPage} 
                page={pageNum} 
                onChange={(event, value) => handlePagination(event, value)}
            />
                       {requestModal && 
                <ClosedModal 
                  open={requestModal}
                  handleClose={notToCancel}
                  data={closeRequestModalData}
                  isclosingMessage={isclosingMessageBool}
                  closeRequestHandler={closeRequestHandler}
                />
              }
        </>
    );
};

export default Refunded;